module.exports = __webpack_public_path__ + "src/assets/img/bg17.35fc85f6.png";